import { DeleteTwoTone } from '@ant-design/icons';
import { Button, Popconfirm } from 'antd';
import { PopconfirmProps } from 'antd/lib';

export const DeleteAction = ({ onConfirm, disabled }: Omit<PopconfirmProps, 'title'>) => (
  <Popconfirm
    title='Sure to delete?'
    disabled={disabled}
    onConfirm={onConfirm}
  >
    <Button
      type='text'
      size='small'
      disabled={disabled}
      icon={(
        <DeleteTwoTone
          title='Delete'
          twoToneColor={disabled ? '#bfbfbf' : '#FF4D4F'}
        />
      )}
    />
  </Popconfirm>
);
